import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ShieldCheck, Star, MapPin } from "lucide-react";
import Navbar from "@/components/Navbar";

export default function ProviderProfile() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => { api.get(`/providers/${id}`).then(({ data }) => setP(data)); }, [id]);

  const book = () => {
    if (!user) { nav(`/login`); return; }
    nav(`/book/${id}`);
  };

  if (!p) return (<div className="min-h-screen bg-white"><Navbar /><div className="max-w-4xl mx-auto p-8">Loading…</div></div>);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="card">
          <div className="flex flex-col sm:flex-row gap-6 items-start">
            <div className="w-20 h-20 rounded-2xl bg-emerald-500 text-white inline-flex items-center justify-center text-3xl font-bold">
              {(p.business_name || "?").slice(0,1)}
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <h1 className="font-display text-3xl font-bold text-slate-900">{p.business_name}</h1>
                {p.verified && <span className="badge-verified"><ShieldCheck size={12} /> Verified</span>}
              </div>
              <div className="text-slate-600 mt-1 flex items-center gap-3 text-sm flex-wrap">
                <span className="inline-flex items-center gap-1"><Star size={14} className="text-amber-500" /> {p.rating_avg?.toFixed?.(1) || "New"} · {p.review_count || 0} reviews</span>
                <span className="inline-flex items-center gap-1"><MapPin size={14} /> {(p.postcodes || []).slice(0,4).join(", ") || "Liverpool"}</span>
              </div>
              <p className="mt-4 text-slate-700">{p.bio || "Local expert ready to help with your job."}</p>
              <div className="mt-4 flex items-center justify-between">
                <div className="font-semibold text-lg text-slate-900">{p.hourly_rate ? `From £${p.hourly_rate}/hr` : "Custom quotes"}</div>
                <button data-testid="provider-book-btn" onClick={book} className="btn-accent">Request a quote</button>
              </div>
            </div>
          </div>
        </div>

        <h2 className="font-display text-2xl font-bold mt-10 mb-4">Reviews</h2>
        <div className="space-y-4">
          {(p.reviews || []).length === 0 && <div className="card text-slate-600">No reviews yet.</div>}
          {(p.reviews || []).map((r) => (
            <div key={r.id} className="card">
              <div className="flex items-center gap-2">
                <div className="font-semibold text-slate-900">{r.customer_name}</div>
                <span className="inline-flex items-center gap-1 text-amber-500 text-sm"><Star size={14} /> {r.rating}</span>
              </div>
              <p className="text-slate-700 mt-2">{r.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
